export default __webpack_public_path__ + "static/media/kitchen3-afterI.96c55bc8.jpg";